export default function WhyProgramsWork() {
  const cards = [
    { icon: 'ri-magic-line', title: 'Диагностика до обучения', desc: 'Перед тренингом мы изучаем реальные звонки, CRM-данные и проводим интервью с руководителями и менеджерами. Это позволяет настроить программу точно под ваши задачи.' },
    { icon: 'ri-phone-line', title: 'Изучаем реальные звонки', desc: 'Прослушиваем 20-30 записей разговоров менеджеров. Анализируем: где теряется клиент, какие ошибки системные, какие индивидуальные.' },
    { icon: 'ri-bar-chart-2-line', title: 'Изучаем CRM', desc: 'Анализируем воронку: конверсию по этапам, длительность цикла, причины отказов. Данные показывают реальную картину эффективности.' },
    { icon: 'ri-team-line', title: 'Проводим интервью', desc: 'Беседуем с руководителем и менеджерами. Понимаем контекст: продукт, рынок, цикл сделки, типичные сложности.' },
    { icon: 'ri-settings-3-line', title: 'Настраиваем программу под компанию', desc: 'Каждая программа уникальна. Учитываем отрасль, продукт, цикл сделки и текущий уровень команды.' },
    { icon: 'ri-tools-line', title: 'Практика на ваших кейсах', desc: 'Никаких абстрактных примеров. Все упражнения и ролевые игры строятся на реальных сценариях из вашей практики.' },
    { icon: 'ri-file-search-line', title: 'Работаем с реальными переговорами', desc: 'Разбираем записи звонков участников на тренинге. Это в десятки раз эффективнее теории.' },
    { icon: 'ri-task-line', title: 'Домашние задания', desc: 'Между модулями участники применяют новые навыки в работе. Результаты разбираем на следующей встрече.' },
    { icon: 'ri-road-map-line', title: 'Полевое сопровождение', desc: 'После тренинга выезжаем в компанию, слушаем новые звонки, даём обратную связь в реальном времени.' },
    { icon: 'ri-feedback-line', title: 'Разбор звонков после тренинга', desc: 'Периодический аудит записей: проверяем, как закрепились навыки, корректируем стратегию.' },
    { icon: 'ri-telegram-line', title: 'Telegram-поддержка', desc: 'Оперативная обратная связь. Участники присылают записи сложных звонков и получают разбор.' },
    { icon: 'ri-survey-line', title: 'Контроль внедрения', desc: 'Через 1-3 месяца проводим контрольный срез: изменилась ли конверсия, выросла ли активность.' },
    { icon: 'ri-book-2-line', title: 'Авторская Книга продаж', desc: 'По итогам программы формируем Книгу продаж — свод стандартов и лучших практик компании.' },
    { icon: 'ri-line-chart-line', title: 'Измеримые KPI', desc: 'Фиксируем исходные показатели до обучения и отслеживаем динамику: конверсия, встречи, продажи.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-shield-check-line"></i>
            Не стандартные тренинги
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему наши программы работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Мы строим обучение иначе. Не просто проводим семинар — а сопровождаем внедрение изменений на каждом этапе.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-16">
          {cards.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 hover:bg-teal-50/50 transition-colors group border border-transparent hover:border-teal-100">
              <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-user-follow-line text-3xl text-white"></i>
          </div>
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed">
            Мы сопровождаем внедрение изменений, а не просто проводим обучение.
          </p>
        </div>
      </div>
    </section>
  );
}